import { render, staticRenderFns } from "./generator.counter.checkbox.vue?vue&type=template&id=0be8d867&"
import script from "./generator.counter.checkbox.vue?vue&type=script&lang=ts&"
export * from "./generator.counter.checkbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports